import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

import { useViewerProfile } from '@/auth/useViewerProfile';
import { RoutesEnum } from '@/enums';
import { UserRole } from '@/types/users';

type RoleGuardProps = PropsWithChildren<{
  allowedRoles: UserRole[];
}>;

export const RoleGuard = ({ children, allowedRoles }: RoleGuardProps) => {
  const { role, isRoleLoading } = useViewerProfile();

  if (isRoleLoading) {
    return null;
  }

  if (!role || !allowedRoles.includes(role)) {
    return <Navigate to={RoutesEnum.DAILY_SURVEY_OVERVIEW} replace />;
  }

  return <>{children}</>;
};
